"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCookbookFromCollectionMutationOptions = exports.removeCookbookFromCollectionMutation = void 0;
const client_1 = require("@apollo/client");
const browseCookbook_1 = require("../queries/browseCookbook");
const updateQuery_1 = require("../../../utils/updateQuery");
exports.removeCookbookFromCollectionMutation = client_1.gql `
  mutation RemoveCookbookFromCollection($cookbookId: String!) {
    removeCookbookFromCollection(cookbookId: $cookbookId) {
      ok
    }
  }
`;
exports.removeCookbookFromCollectionMutationOptions = (variables) => ({
    variables,
    update: store => {
        updateQuery_1.updateQuery(store, browseCookbook_1.cookbooksQuery, x => {
            x.cookbooks = x.cookbooks.filter(y => y.id !== variables.cookbookId);
        });
    },
});
//# sourceMappingURL=removeCookbookFromCollection.js.map